import { render, staticRenderFns } from "./PorcentajeSubtipos.vue?vue&type=template&id=c961c06a&"
import script from "./PorcentajeSubtipos.vue?vue&type=script&lang=js&"
export * from "./PorcentajeSubtipos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports